import type { StringLikeChildren } from '../components/types.js';

export function stringLikeChildrenToString(children: StringLikeChildren): string {
  return typeof children === 'string' ? children : typeof children === 'number' ? String(children) : children.join('');
}
